var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticStyle:{"margin-bottom":"1.5%"},attrs:{"searchable":true,"filterable":false,"id":_vm.index+'_service_'+_vm.appointmentId,"reduce":s => s.id,"label":"name","options":_vm.sutList},on:{"search":_vm.getSutList},model:{value:(_vm.selectedSutCode),callback:function ($$v) {_vm.selectedSutCode=$$v},expression:"selectedSutCode"}})
}
var staticRenderFns = []

export { render, staticRenderFns }